<mat-card>
  <mat-card-title-group>
    <mat-card-title>Bankoplysninger</mat-card-title>
    <mat-card-subtitle>{{customer.name}}</mat-card-subtitle>
  </mat-card-title-group>
  <mat-card-content>
    <div fxLayout="row" fxLayoutGap="1em" fxLayoutAlign="space-between top">
      <dl fxFlex="25">
        <dt>Bank</dt>
        <dd>
          @switch (customer.wealth_manager.bank) {
            @case ('generic') {
              <span>Ingen/generisk</span>
            }
            @case ('danske_bank') {
              <span>Danske Bank District</span>
            }
            @case ('danske_forvaltning') {
              <span>Danske Bank Forvaltning</span>
            }
            @case ('jyske_bank') {
              <span>Jyske Bank</span>
            }
            @case ('bank_connect') {
              <span>BankConnect</span>
            }
            @case ('bank_integration') {
              <span>BankIntegration</span>
            }
            @default {
              <span>Ukendt</span>
            }
          }
        </dd>

        <dt>Depot-/kontonummer</dt>
        <dd>{{customer.wealth_manager.custody_no | accountNumber }}</dd>

        <dt>Valuta</dt>
        <dd>{{customer.currency}}</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="25">
        <dt>NemKonto</dt>
        <dd>{{customer.wealth_manager.nem_konto ? 'Ja' : 'Nej'}}</dd>

        <dt>Regnskabskunde</dt>
        <dd>{{customer.wealth_manager.accounting ? 'Ja' : 'Nej'}}</dd>

      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="25">
        <dt>Overføres betalinger direkte til banken</dt>
        <dd>{{customer.wealth_manager.exports_enabled ? 'Ja' : 'Nej'}}</dd>
      </dl>
    </div>
    <mat-divider [vertical]="false"></mat-divider>
    <div fxLayout="row" fxLayoutGap="1em" fxLayoutAlign="start top">
      <dl fxFlex="50">
        @if (payment_exported_notify.disabled) {
          <div>
            <dt>Email liste for mail med betalingsliste:</dt>
            @for (mail of currentEmailReceivers; track mail) {
              <dd>{{mail}}</dd>
            }
            <button class="mt-3" mat-stroked-button (click)="doEdit()">Rediger</button>
          </div>
        }
        @if (!payment_exported_notify.disabled) {
          <div fxLayout="column">
            <div fxLayout="row">
              <mat-form-field fxFlex="100" class="mb-3">
                <mat-label>Skal modtage notifikation om dagens eksporterede betalinger</mat-label>
                <input type="text" matInput
                  class="form-control"
                  [formControl]="payment_exported_notify"
                  id="email"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addEmail()">
                <mat-hint>Klik Enter, Komma, eller Spacebar for tilføje mail </mat-hint>
              </mat-form-field>
            </div>
            @if (payment_exported_notify.hasError('pattern') && payment_exported_notify.touched) {
              <mat-error>Ugyldig mail.</mat-error>
            }
            <mat-chip-grid #chipList class="mb-3">
              @for (mail of currentEmailReceivers; track mail) {
                <mat-chip selected
                  color="accent"
                  [removable]="true"
                  (removed)="removeMail(mail)">
                  <span>{{mail}}</span>
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              }
            </mat-chip-grid>
            <div>
              <button mat-stroked-button class="mr-3" (click)="doCancel()">Fortryd</button>
              <button mat-flat-button (click)="doSave()" [disabled]="payment_exported_notify.invalid">Gem</button>
            </div>
          </div>
        }
      </dl>
    </div>
  </mat-card-content>
</mat-card>
